import clsx from "clsx";
import React, { useContext, useState } from "react";
import { LanguageContext, text } from "../../container/language";
import { usePageContext } from "../../utils/PageContext";
import Paragraph from "../Article/Paragraph";
import Paragraphs from "../Article/Paragraphs";
import "./style.scss";
import Link from "../../utils/Link";
import { buildURLForCategory, buildURLForMenuItem } from "../../utils/buildURL";
import { useStaticQuery } from "gatsby";

export const query = graphql`
  query {
    api {
      configSocialMediaAndApp {
        facebookUrl
        androidUrl
        instagramUrl
        iosUrl
        linkedinUrl
        twitterUrl
        youtubeUrl
      }
    }
  }
`;

export const ApplicationsDownloadBanner = ({ data }) => {
  const apiData = useStaticQuery(query);
  const social = apiData.api.configSocialMediaAndApp;
  const { lang } = usePageContext();

  return (
    <ul class="apps-list">
      <li class="apps-list__item">
        <a href={social.iosUrl} target="_blank">
          <img src={`/images/app_store___light_${lang}.svg`} alt="App Store" />
        </a>
      </li>
      <li class="apps-list__item">
        <a href={social.androidUrl} target="_blank">
          <img
            src={`/images/google_play___light_${lang}.svg`}
            alt="Google Play"
          />
        </a>
      </li>
    </ul>
  );
};

export default ApplicationsDownloadBanner;
